import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {VscFolderLibrary} from 'react-icons/vsc'

const about = () => {
  return (
    <section id='About'>
       <h5>Get to Know</h5>
       <h2>About ME</h2>
       <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image"/>
          </div>
        </div>
        <div className="about__content">
          <div className='about_cards'>
            <article className='about_card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>0-1 years working</small>
            </article>
            <article className='about_card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>4</small>
            </article>
          </div>
          <p>
 Shivansh is a fourth-year student at VIT-AP, specializing in Computer Science and Engineering with a focus on Artificial Intelligence. Throughout his academic journey, he has exhibited exceptional problem-solving abilities and a strong sense of ownership. His experience in event organization has allowed him to excel in team environments, where he has showcased remarkable leadership skills and excellent time management capabilities.

In terms of technical skills, Shivansh is proficient in various programming languages, including C, Java, and C embedded. He has also acquired expertise in web technologies such as HTML, CSS, JavaScript, and ReactJS, demonstrating his ability to develop interactive and visually appealing web applications. Furthermore, his knowledge extends to database management systems like MySQL, MongoDB, and NoSQL, enabling him to effectively manage and organize large sets of data.</p>
<a href='#contact'className='btn btn-primary'>Lets's Talk</a>
        </div>
       </div>
    </section>
   
  )
}

export default about